import {networker} from "../http";

const iptvService = {
    getPlaylists(accountId){
        return networker.get(`iptv/${accountId}/playlist`)
    },
    getTags(){
        return  networker.get(`iptv/playlist/tags`)
    },
    getChannels(accountID){
        return networker.get(`iptv/${accountID}/channels`)
    },
    editPlaylist(accountId, excludedSid) {
        return networker.post(`iptv/${accountId}/playlist`, excludedSid)
    }
}

export default iptvService